<template>
  <div class="container-project-board flex-column">
    <!-- <div class="project-board-scroll-x"> -->
    <div class="row row-headings g-0 w-100 mt-1">
      <div class="col">
        <div class="story-heading">
          User Story
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Amount of user stories"
            class="count"
            data-bs-original-title="Total count"
          >
            {{ getByFilters().length }}
          </span>
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Sum of user story estimates"
            class="count"
            data-bs-original-title="Sum of user story estimates"
          >
            {{ stories.reduce((prev, next) => prev + next.quoted_estimate, 0) | toHoursMinutes }}
          </span>
          <add-story :sprint="sprint" :saveUserStory="saveUserStory" class="user-story-add"></add-story>
        </div>
      </div>
      <div class="col">
        <div class="story-heading default">
          New
          <span data-bs-toggle="tooltip" data-bs-placement="top" title="" class="count" data-bs-original-title="Unknown">
            {{ getTaskCount('New') }}
          </span>
        </div>
      </div>
      <div class="col">
        <div class="story-heading warning">
          In Progress
          <span data-bs-toggle="tooltip" data-bs-placement="top" title="" class="count" data-bs-original-title="Unknown">
            {{ getTaskCount('In Progress') }}
          </span>
        </div>
      </div>
      <div class="col">
        <div class="story-heading">
          Review
          <span data-bs-toggle="tooltip" data-bs-placement="top" title="" class="count" data-bs-original-title="Unknown">
            {{ getTaskCount('Review') }}
          </span>
        </div>
      </div>
      <div class="col">
        <div class="story-heading success">
          Completed
          <span data-bs-toggle="tooltip" data-bs-placement="top" title="" class="count" data-bs-original-title="Unknown">
            {{ getTaskCount('Completed') }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="loaded">
      <div class="epic" v-for="epic in activeEpics" :key="epic.id">
        <div
          v-collapse="'#collapseEpic' + epic.id"
          class="pb-epic-heading"
          aria-expanded="false"
        >
          <i class="far fa-fw fa-chevron-down"></i>
          {{ epic.title }}
        </div>

        <div v-bind:id="'collapseEpic' + epic.id" class="collapse show">
          <story
            render-tasks
            show-actions
            v-for="story in getByEpicIdAndFilters(epic.id)"
            :key="story.id"
            :story="story"
          ></story>
        </div>
      </div>

      <div class="epic" :key="-1">
        <div
          v-collapse="'#collapseEpic' + -1"
          class="pb-epic-heading"
          aria-expanded="false"
        >
          <i class="far fa-fw fa-chevron-down"></i>
          Unknown
        </div>

        <div v-bind:id="'collapseEpic' + -1" class="collapse show">
          <story
            render-tasks
            show-actions
            v-for="story in getByEpicIdAndFilters(null)"
            :key="story.id"
            :story="story"
          ></story>
        </div>
      </div>
    </div>

    <!-- </div> -->

    <filterDrawer ref="filtersDrawer" />
    <render-options-drawer ref="renderOptionsDrawer" />
    <doc-link-drawer ref="docLinkDrawer" />
    <router-view v-if="loaded"></router-view>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { filter } from 'lodash'
var Sticky = require('sticky-js')
import { echo } from 'mixins'

import story from './_story'
import filterDrawer from './FilterDrawer'
import RenderOptionsDrawer from '../sprintplanner/RenderOptionsDrawer'
import addStory from './_add-story'
import DocLinkDrawer from './DocLinkDrawer'

import dragAndDrop from 'mixins/scrumboard/drag-and-drop'
import boardDrawers from 'mixins/scrumboard/board-drawers'

export default {
  props: ['userStoryDocId'],
  mixins: [dragAndDrop, echo, boardDrawers],
  components: {
    story,
    filterDrawer,
    RenderOptionsDrawer,
    addStory,
    DocLinkDrawer,
  },

  data: function () {
    return {
      focusStoryId: null,
      loaded: false,
      members: [],
    }
  },

  watch: {
    '$route.params.sprint_id'(newVal, oldVal) {
      this.loaded = false

      this.echo.leave(`channel-yodiz-${oldVal}`)

      this.$store.dispatch('yodizproject/tasks/clearData', [])
      this.$store.dispatch('yodizproject/stories/clearData', [])
      this.$store.dispatch('yodizproject/effort/clearData', [])

      this.loadSprintData(newVal).then(() => {
        this.loadStories().then(() => {
          this.joinPresenceChannel()
        })
      })
    },
  },
  async mounted() {
    this.echoConnect()
    this.loadData()

    console.log('sprint_id', this.$route.params.sprint_id)

    this.$bus.$on('us-doc-link', ({ storyId, userStoryDocId }) => {
      this.$refs.docLinkDrawer.open({ storyId, userStoryDocId })
    })
  },
  beforeDestroy: function () {
    this.$bus.$off('us-doc-link')
    // const channel = this.$root.pusher.unsubscribe('presence-channel-'+this.project.id);
    this.echo.leave(`channel-yodiz-usd-${this.$route.params.user_story_doc_id}`)
    this.echoDisconnect()
    this.$store.dispatch('yodizproject/tasks/clearData', [])
    this.$store.dispatch('yodizproject/stories/clearData', [])
    this.$store.dispatch('yodizproject/effort/clearData', [])
  },

  computed: {
    ...mapState('yodizproject', {
      project: 'single',
    }),

    ...mapState('yodizproject/sprints', {
      sprint: 'single',
      sprints: 'list',
    }),

    ...mapState('yodizproject/epics', {
      epics: 'list',
    }),

    ...mapState('users', ['users']),

    ...mapState('yodizproject/stories', {
      stories: 'list',
    }),

    ...mapState('yodizproject/tasks', {
      tasks: 'list',
    }),

    ...mapGetters('yodizproject/stories', {
      getByFilters: 'getByFilters',
      getByEpicIdAndFilters: 'getByEpicIdAndFilters',
    }),

    ...mapGetters('yodizproject/tasks', {
      getCountOfStatus: 'getCountOfStatus',
    }),

    ...mapGetters('yodizproject/sprints', {
      getActiveSprint: 'getActiveSprint',
    }),

    activeEpics() {
      return this.epics.filter((epic) => {
        if (this.getByEpicIdAndFilters(epic.id).length > 0) return true
      })
    },
  },

  methods: {
    ...mapActions('yodizproject/stories', {
      getStories: 'getList',
      storeUserStory: 'addListObject',
      addStory: 'addFromLocalToList',
      updateStory: 'updateFromLocalToList',
      deleteStory: 'deleteFromLocalToList',
    }),

    ...mapActions('users', {
      getUsers: 'getUsers',
    }),

    ...mapActions('yodizuserstorydoc', {
      getUserStoryDoc: 'getSingle',
    }),

    ...mapActions('yodizproject/sprints', {
      getSprints: 'getList',
      getSprint: 'getSingle',
    }),

    ...mapActions('yodizproject/stages', {
      getStage: 'getSingle',
    }),
    ...mapActions('yodizproject/epics', {
      getEpics: 'getList',
      addEpic: 'addFromLocalToList',
    }),
    ...mapActions('yodizproject/tasks', {
      addItem: 'addFromLocalToList',
      updateItem: 'updateIfLatestVersion',
      deleteItem: 'deleteFromLocalToList',
    }),
    ...mapActions('yodizproject/effort', {
      addEffort: 'addFromLocalToList',
      updateEffort: 'updateFromLocalToList',
      deleteEffort: 'deleteFromLocalToList',
    }),

    ...mapActions('yodizproject/tags', {
      getTags: 'getList',
    }),

    async connectChannels () {

    },

    joinPresenceChannel() {
      this.echo
        .join(`channel-yodiz-usd-${this.$route.params.user_story_doc_id}`)
        .here((users) => {
          this.members = users
        })
        .joining((user) => {
          this.members.push(user)
        })
        .leaving((user) => {
          for (var i = 0; i <= this.members.length - 1; i++) {
            if (this.members[i].id == user.id) {
              this.members.splice(i, 1)
            }
          }
        })
        .listen('Yodiz.newEpicBroadcast', (data) => {
          this.addEpic([data.epic])
        })
        .listen('Yodiz.newStoryBroadcast', (data) => {
          if (data.story.sprint_id == this.sprint.id) {
            this.addStory([data.story])
          }
        })
        .listen('Yodiz.updateStoryBroadcast', (data) => {
          if (data.story.sprint_id == this.sprint.id) {
            this.updateStory(data.story)
          }
        })
        .listen('Yodiz.deleteStoryBroadcast', (data) => {
          if (data.story.sprint_id == this.sprint.id) {
            this.deleteStory(data.story.id)
          }
        })
        .listen('Yodiz.newItemBroadcast', (data) => {
          if (this.stories.some((story) => story.id === data.item.story_id)) {
            this.addItem([data.item])
          }
        })
        .listen('Yodiz.updateItemBroadcast', (data) => {
          if (this.stories.some((story) => story.id === data.item.story_id)) {
            this.updateItem(data.item)
          }
        })
        .listen('Yodiz.deleteItemBroadcast', (data) => {
          if (this.stories.some((story) => story.id === data.item.story_id)) {
            this.deleteItem(data.item.id)
          }
        })
        .listen('Yodiz.newEffortBroadcast', (data) => {
          let classMapper = {
            'Carbon\\Yodiz\\Task': 'tk-',
            'Carbon\\Yodiz\\Issue': 'bg-',
          }

          if (
            this.tasks.some(
              (task) => task.id == classMapper[data.timeEntry.entryable_type] + data.timeEntry.entryable_id
            )
          ) {
            this.addEffort([data.timeEntry])
          }
        })
        .listen('Yodiz.updateEffortBroadcast', (data) => {
          this.updateEffort(data.timeEntry)
        })
        .listen('Yodiz.deleteEffortBroadcast', (data) => {
          this.deleteEffort(data.timeEntry.id)
        })
    },

    loadStories() {
      return this.getStories().then(() => {
        //Populate the tasks from eagerloaded data
        let items = []
        let effort = []

        this.stories.forEach((item) => {
          if (item.tasks) {
            item.tasks.forEach((task) => {
              effort = effort.concat(task.timeEntries)
              delete task.timeEntries
            })

            items = items.concat(item.tasks)
          }

          if (item.issues) {
            item.issues.forEach((issue) => {
              effort = effort.concat(issue.timeEntries)
              delete issue.timeEntries
            })

            items = items.concat(item.issues)
          }
        })

        this.$store.dispatch('yodizproject/tasks/addFromLocalToList', items).then(() => {
          this.loaded = true
        })

        this.$store.dispatch('yodizproject/effort/addFromLocalToList', effort).then(() => {})
      })
    },

    loadData() {
      this.getUsers()

      this.getUserStoryDoc(this.$route.params.user_story_doc_id).then(() => {
        this.getEpics()
        this.getSprints().then(() => {
          this.loadSprintData().then(() => {
            this.loadStories()
            this.joinPresenceChannel()
          })
        })
      })

      this.getTags({ area: 'scrumboard' })
    },

    getTaskCount(status) {
      //This could be improved as its currently being called for each task status
      let storyIds = this.getByFilters().map((story) => {
        return story.id
      })

      return this.getCountOfStatus(storyIds, status)
    },
    loadSprintData(sprintId = null) {
      if (sprintId > 0) {
        this.activeSprintId = sprintId
      } else {
        if (/^\d+$/.test(this.$route.params.sprint_id)) {
          this.activeSprintId = this.$route.params.sprint_id
        } else {
          let activeSprint = this.getActiveSprint()

          if (activeSprint) {
            this.activeSprintId = activeSprint.id
          } else {
            //default to last
            this.activeSprintId = this.sprints[this.sprints.length - 1].id
          }
        }
      }

      return this.getSprint(this.activeSprintId)
    },
    saveUserStory(story) {
      return this.storeUserStory({
        payload: Object.assign(story, {
          sprint_id: this.sprint.id,
          user_story_document_id: this.$route.params.user_story_doc_id,
          project_id: this.$route.params.project_id,
        }),
      })
    },
  },
}
</script>

<style >
</style>
